import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="w-full bg-plum py-10 text-cream/70" data-id="element-70" data-mp="3gezf99jl213s">
      <div className="mx-auto max-w-6xl px-5 text-center sm:px-6" data-id="element-71" data-mp="3ghc3u5juj9pt">
        <p className="font-display text-lg font-semibold text-cream" data-id="element-72" data-mp="32ovzn1f7l5nb">{PRODUCT_NAME}</p>
        <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-cream/50" data-id="element-73" data-mp="36ooaxlvzlpwd">
          Este ebook brinda herramientas, estrategias y recursos educativos. Los resultados
          económicos dependen de la aplicación, constancia y circunstancias de cada persona. La
          garantía se aplica durante los 7 días corridos posteriores a la compra.
        </p>
        <p className="mt-6 text-xs text-cream/40" data-id="element-74" data-mp="3qdf2h1fhoq80">
          © {new Date().getFullYear()} {PRODUCT_NAME}. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}